export default __webpack_public_path__ + "static/media/016-skull.08f9b931.svg";